/* Shiok /cart upsell, oysters and lobster for BBQ Assistant orders (Boss 2026-10-13).
   Port of the approved draft (Cart Upsell Lobster Oyster - BBQ Assistant/cart-upsell-lobster-oyster.html).
   Config, prices and stock come from snippets/shiok-cart-upsell.liquid, printed on the cart template only.
   1. Shows only when the cart holds a product of live-station-bbq-assistant-package that is not a DIY variant.
   2. Opens 3 seconds after the cart page has fully loaded (Boss 2026-10-13, was 2 s from landing).
   3. Offers the configured products minus any already in the cart. Nothing left = no popup.
   4. Closed once = not shown again this browser visit (sessionStorage).
   5. An add goes to /cart/add.js; when the popup closes after an add, the cart page reloads to show it. */
(function () {
  'use strict';
  if (window.ShiokCartUpsell) return;
  var cfgEl = document.getElementById('shiokCartUpCfg');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var DELAY = 3000, SEEN = 'shiokCartUpSeen';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* popup copy, approved by Boss 2026-10-13 */
  var COPY = { h: 'Craving a taste of the sea?', s: 'Ice cold oysters, sweet and briny. Tender Boston lobster soaked in smoked garlic butter. The bite your guests will remember.', done: 'No thanks, back to my cart', add: 'Add', adding: 'Adding...', added: 'Added', again: 'Try again', sold: 'Sold out' };
  /* popup only labels and lines per product (never written back to the product, lesson 309) */
  var CARD = {
    'live-oyster-party-pack': { title: 'Live Oyster Party Pack (60pcs)', sub: '5 dozen live oysters per set', o: ['Oyster', 'How you want them'],
      why: 'Smooth, sweet and briny, slurped ice cold with fresh lemon and a dash of Tabasco.' },
    'salt-works-trio-de-claire-sg61-edition-60-pcs-1-caviar': { title: 'Salt Works Trio de Claire', sub: '60 oysters, 3 French Claire varieties', o: ['How you want them', 'Set'],
      why: 'Briny sweet with a clean mineral finish. Rested in French clay beds, best slurped ice cold.' },
    'the-boston-lobster-party-pack-4-pcs': { title: 'The Too Good To Be True Live Boston Lobster Bundle', sub: '4 lobsters, 400g to 500g each', o: ['Prep style', 'Butter'],
      why: 'Sweet, tender lobster meat. Even better with our smoked garlic, dill lemon or togarashi butter.' }
  };

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var money = function (c) { var n = (Math.round(c) / 100).toFixed(2).split('.'); return '$' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]; };
  var uniq = function (a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); };
  var avail = function (o) { return o.v.filter(function (x) { return x[4]; }); };
  function seen() { try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(SEEN, '1'); } catch (e) {} }
  function isAssist(it) { return !!CFG.assist[it.handle] && !/\bdiy\b/i.test(String(it.variant_title || '')); }
  function pick(o, a, b) { return o.v.filter(function (x) { return x[1] === a && x[2] === b && x[4]; })[0] || null; }

  var addedAny = false;
  function card(o, i) {
    var C = CARD[o.h] || {}, d = avail(o)[0];
    var labels = C.o || o.o || [];
    var o1 = uniq(avail(o).map(function (x) { return x[1]; })), o2 = uniq(avail(o).filter(function (x) { return x[1] === d[1]; }).map(function (x) { return x[2]; }));
    var sel = function (n, list, cur, lab) {
      if (!list.length || (list.length === 1 && list[0] === null)) return '';
      return '<label' + (list.length < 2 ? ' hidden' : '') + '>' + esc(lab) + '<select data-opt="' + n + '" data-i="' + i + '">' +
        list.map(function (x) { return '<option' + (x === cur ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('') + '</select></label>';
    };
    var title = C.title || o.title;
    return '<div class="pf-ui" data-card="' + i + '">' + (o.img ? '<img src="' + esc(o.img) + '" alt="' + esc(title) + '" width="96" height="96" loading="lazy">' : '<span></span>') + '<div>' +
      '<b>' + esc(title) + '</b>' + (C.sub ? '<small>' + esc(C.sub) + '</small>' : '') + (C.why ? '<p>' + esc(C.why) + '</p>' : '') +
      '<div class="pf-ui__opts">' + sel(1, o1, d[1], labels[0]) + sel(2, o2, d[2], labels[1]) + '</div>' +
      '<div class="pf-ui__f"><span data-price>' + money(d[3]) + '</span><button type="button" class="pf-ui__add" data-add="' + i + '">' + COPY.add + '</button></div></div></div>';
  }

  /* GA4, same events and params as the package popup (shiok-upsell.js) so Rose's tracker Sheet merges them; this popup is
     upsell_kind cart_sea (Boss 2026-10-22). Silent when gtag is missing. */
  var KIND = 'cart_sea', addedCount = 0;
  function ga(name, p) {
    try { if (typeof window.gtag === 'function') { p.send_to = 'G-Q2S5DM0RB8'; window.gtag('event', name, p); } } catch (e) {}
  }
  function close(method) {
    var u = document.getElementById('scUp'); if (!u) return;
    u.remove();
    ga('upsell_popup_closed', { upsell_kind: KIND, close_method: method || 'other', upsell_added_count: addedCount });
    markSeen();
    if (addedAny) location.reload();
  }

  function open(offers) {
    var html = '<div class="pf-up shiok-up sc-up" id="scUp" role="dialog" aria-modal="true" aria-labelledby="scUpH"><div class="pf-up__box" data-bg="brick">' +
      '<button type="button" class="pf-up__x" data-x aria-label="Close">&times;</button>' +
      '<h2 id="scUpH">' + esc(COPY.h) + '</h2><p class="pf-up__sub">' + esc(COPY.s) + '</p>' +
      offers.map(card).join('') +
      '<button type="button" class="pf-btn pf-up__done" data-x>' + esc(COPY.done) + '</button></div></div>';
    document.body.insertAdjacentHTML('beforeend', html);
    var u = document.getElementById('scUp');
    ga('upsell_popup_shown', { upsell_kind: KIND, upsell_items_offered: offers.length });
    var chosen = offers.map(function (o) { return avail(o)[0]; });

    u.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-opt]'); if (!s) return;
      var i = +s.dataset.i, o = offers[i], c = u.querySelector('[data-card="' + i + '"]');
      var s1 = c.querySelector('select[data-opt="1"]'), s2 = c.querySelector('select[data-opt="2"]');
      if (s.dataset.opt === '1' && s2) {
        var list = uniq(o.v.filter(function (x) { return x[1] === s1.value && x[4]; }).map(function (x) { return x[2]; }));
        var keep = list.indexOf(s2.value) >= 0 ? s2.value : list[0];
        s2.innerHTML = list.map(function (x) { return '<option' + (x === keep ? ' selected' : '') + '>' + esc(x) + '</option>'; }).join('');
        s2.parentNode.hidden = list.length < 2;
      }
      var v = pick(o, s1 ? s1.value : null, s2 ? s2.value : null); chosen[i] = v;
      var b = c.querySelector('[data-add]'), p = c.querySelector('[data-price]');
      p.textContent = v ? money(v[3]) : COPY.sold;
      if (!b.classList.contains('is-done')) { b.disabled = !v; b.textContent = v ? COPY.add : COPY.sold; }
    });

    u.addEventListener('click', function (e) {
      if (e.target === u) { close('outside'); return; }
      var x = e.target.closest('[data-x]');
      if (x) { close(x.classList.contains('pf-up__done') ? 'done_button' : 'x_button'); return; }
      var b = e.target.closest('[data-add]'); if (!b || b.disabled) return;
      var i = +b.dataset.add, v = chosen[i]; if (!v) return;
      b.disabled = true; b.textContent = COPY.adding;
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Shiok-Upsell': '1' }, body: JSON.stringify({ items: [{ id: v[0], quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { addedAny = true; addedCount++; ga('upsell_popup_add', { upsell_kind: KIND, upsell_item: offers[i].h }); b.textContent = COPY.added; b.classList.add('is-done'); })
        .catch(function () { b.disabled = false; b.textContent = COPY.again; });
    });
  }

  function start() {
    if (seen()) return;
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var items = (cart && cart.items) || [];
      if (!items.some(isAssist)) return;
      var have = {}; items.forEach(function (it) { have[it.handle] = true; });
      var offers = (CFG.offers || []).filter(function (o) { return !have[o.h] && avail(o).length; });
      if (!offers.length) return;
      /* counted from the moment the page has FULLY loaded (window load), so the cart settles first (Boss 2026-10-13) */
      var go = function () { setTimeout(function () { if (!document.getElementById('scUp')) open(offers); }, DELAY); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    }).catch(function () {});
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('scUp')) close('escape'); });
  window.ShiokCartUpsell = { start: start, open: open, isAssist: isAssist, CFG: CFG };   /* QA hook */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
